import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAttendanceByDate = async ({
  companyCode,
  locationCode,
  filterDate,
}) => {
  if (companyCode ) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmpAttendanceBydate}?CompanyCode=${companyCode}&AttDate=${filterDate}&LocationCode=${locationCode}`
    );
    return data;
  }
  return [];
};

const getAttendanceTimeLog = async ({
  companyCode,
  locationCode,
  attendanceDate,
  employeeCode,
  departmentCode,
}) => {
  let queryString = `?companyCode=${companyCode}&AttendanceDate=${attendanceDate}&LocationCode=${locationCode}`;
  if (departmentCode !== 0) {
    queryString += `&Departmentcode=${departmentCode}`;
  }

  if (employeeCode !== 0) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }

  if (companyCode ) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetAttendanceTimeLog}${queryString}`
    );
    return data;
  }
  return [];
};

export const useGetEmpAttendanceByDateQuery = ({ companyCode, filterDate }) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmpAttendanceBydate],
    queryFn: () => getAttendanceByDate({ companyCode, filterDate }),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};

export const useGetAttendanceTimeLogQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAttendanceTimeLog],
    queryFn: () => getAttendanceTimeLog(input),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};
